import React from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import AdminOnboardingFieldLabel from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingMultiSelect';
import {
  companySizeOptions,
  roleOptions,
  teamOptions,
} from 'common/subdomain/admin/AdminOnboarding/data';
import SingleSelect from 'common/ui/SingleSelect';
import VStack from 'common/ui/VStack';

import type { RegistrationStepProps } from 'common/subdomain/admin/AdminOnboarding/Types';
import type { Option } from 'common/ui/common/select/SelectCommon';

const AdminOnboardingTeam = ({ onChange, onboarding }: RegistrationStepProps) => {
  const onChangeCompanySize = (option?: Option) => {
    onChange({
      companySize: option?.value || null,
    });
  };

  const onChangeRole = (option?: Option) => {
    onChange({
      role: option?.value || null,
    });
  };

  const onChangeTeams = (teams: string[]) => {
    onChange({
      teams,
    });
  };

  const getCompanySizeValue = (): Option | undefined => {
    if (!onboarding.companySize) {
      return undefined;
    }
    return (
      companySizeOptions.find((option) => option.value === onboarding.companySize) || undefined
    );
  };

  const getRoleValue = (): Option | undefined => {
    if (!onboarding.role) {
      return undefined;
    }
    return roleOptions.find((option) => option.value === onboarding.role) || undefined;
  };

  return (
    <RegistrationWrapper.Content>
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Tell us about your team</RegistrationWrapper.Title>
        <RegistrationWrapper.Description>
          This helps us tailor your experience and give you more relevant tips
        </RegistrationWrapper.Description>
      </RegistrationWrapper.Header>
      <VStack className="gap-7">
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>
            How many people work at your company?
          </AdminOnboardingFieldLabel>
          <SingleSelect
            onChange={onChangeCompanySize}
            options={companySizeOptions}
            placeholder="Choose a size"
            className="max-w-[260px]"
            value={getCompanySizeValue()}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>What is your role?</AdminOnboardingFieldLabel>
          <SingleSelect
            onChange={onChangeRole}
            options={roleOptions}
            placeholder="Choose a role"
            className="max-w-[260px]"
            value={getRoleValue()}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Which teams will be using Canny?</AdminOnboardingFieldLabel>
          <AdminOnboardingMultiSelect
            onChange={onChangeTeams}
            options={teamOptions}
            selected={onboarding.teams || []}
          />
        </VStack>
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingTeam;
